import { render } from "./FarmerDisplay.vue?vue&type=template&id=003f1034&ts=true"
import script from "./FarmerDisplay.vue?vue&type=script&lang=ts"
export * from "./FarmerDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__